/* eslint-disable import/prefer-default-export */
export { localize } from './localization';
